/** Read-only or interactive 1–5 star rating. */
export function Stars({
  value,
  count,
  onRate,
  size = 16,
}: {
  value: number | null;
  count?: number;
  onRate?: (rating: number) => void;
  size?: number;
}) {
  const rounded = value ?? 0;
  return (
    <span className="stars" style={{ fontSize: size }}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= Math.round(rounded);
        return onRate ? (
          <button
            key={n}
            type="button"
            className="star-btn"
            aria-label={`${n} stars`}
            onClick={() => onRate(n)}
          >
            {filled ? "★" : "☆"}
          </button>
        ) : (
          <span key={n} className={filled ? "star on" : "star"}>
            {filled ? "★" : "☆"}
          </span>
        );
      })}
      {value != null && count != null && count > 0 && (
        <span className="stars-count">
          {value.toFixed(1)} ({count})
        </span>
      )}
    </span>
  );
}
